module.exports = __webpack_public_path__ + "static/media/Tyrion Lannister.bcdb97a5.jpg";